import React from 'react';
import { IArticle } from '../types';

// eslint-disable-next-line @typescript-eslint/naming-convention
const otvetstvennost_za_shtrafi: IArticle = {
  title:
    'Ответственность и штрафы за отсутствие маркировки рекламы в интернете',
  image: '/assets/img/blog/otvetstvennost_za_shtrafi.jpeg',
  prewievImage: '/assets/img/blog/otvetstvennost_za_shtrafi-prewiev.jpeg',
  content: [
    {
      text: [
        '1 сентября 2023 года были введены штрафы и вступил в силу Закон об административной ответственности за нарушение норм и правил маркировки интернет рекламы, размеры которых зависят от типа правонарушения.',
      ],
    },
    {
      subTitle: 'Сопутствующие документы:',
      text: [
        <ul>
          <li>
            Федеральный закон № 347-ФЗ от 02.07.2021 г. «О внесении изменений в
            Федеральный закон о рекламе».
          </li>
          <li>
            Федеральный закон N 38-ФЗ &quot;О рекламе&quot; Статья 18. от
            13.03.2006 г. «Реклама, распространяемая по сетям электросвязи».
          </li>
          <li>
            Федеральный закон № 274-ФЗ от 24.06.2023 г. «О внесении изменений в
            Кодекс Российской Федерации об административных правонарушениях».
          </li>
          <li>
            Федеральный закон № 479-ФЗ от 26.12.2024 г. «О внесении изменений в
            Федеральный закон «О рекламе» и отдельные законодательные акты
            Российской Федерации».
          </li>
          <li>
            Федеральный закон от 13.03.2006 N 38-ФЗ (ред. от 23.11.2024) &quot;О
            рекламе&quot; (с изм. и доп., вступ. в силу с 01.01.2025).
          </li>
        </ul>,
      ],
    },
    {
      subTitle: 'К видам нарушений правил маркировки относятся:',
      text: [
        <ul>
          <li>
            непредоставление информации о рекламе в ЕРИР, а также предоставление
            неполных, недостоверных, неактуальных данных;
          </li>
          <li>
            распространение рекламы без специального идентификатора (erid), либо
            с нарушением норм размещения;
          </li>
          <li>
            отсутствие в рекламной публикации пометки «реклама» и/или указания
            рекламодателя.
          </li>
        </ul>,
        <>
          Подробно о правилах оформления рекламных публикаций мы рассказали в
          статье{' '}
          <a href="/blog/poryadok_razmeshenia_markera_v_reklame">
            «Порядок размещения маркера (erid:xxxxx) в рекламе с примерами»
          </a>
          .
        </>,
      ],
    },
    {
      subTitle: 'Размеры штрафов за нарушение правил маркировки:',
      text: [
        <ul>
          <li>Для физических лиц: от 10 000 до 30 000 рублей;</li>
          <li>
            Для должностных лиц и индивидуальных предпринимателей: от 30 000 до
            100 000 рублей;
          </li>
          <li>Для организаций: от 200 000 до 500 000 рублей.</li>
        </ul>,
        'Суммы штрафов для операторов рекламных данных за несоблюдение требований при передаче информации в Роскомнадзор:',
        <ul>
          <li>Для должностных лиц: от 100 000 до 200 000 рублей;</li>
          <li>• Для организаций: от 300 000 до 700 000 рублей.</li>
        </ul>,
      ],
    },
    {
      subTitle: 'Что такое реклама?',
      text: [
        <>
          Федеральная антимонопольная служба (ФАС) определяет рекламу как
          информацию, которая распространяется любым доступным способом, в
          различных форматах и при помощи различных средств. Она предназначена
          для неопределённой аудитории и направлена на привлечение интереса к
          рекламируемому объекту, а также на формирование или поддержание
          интереса и продвижение этого объекта на рынке.
        </>,
        'Исключения из определения интернет-реклама составляют email-рассылки, push-уведомления, рассылаемые по собственной клиентской базе.',
      ],
    },
    {
      subTitle: 'Что считать рекламой?',
      text: [
        'Согласно разъяснениям ФАС не считается рекламой: информация о товарах и услугах, размещённая на официальных сайтах их производителя / продавца, или в публичных аккаунтах социальных сетей. Также к рекламе не относятся обзоры товаров от разных производителей в видеоролике или блоге, если их главная цель не состоит в продвижении какого-либо товара на рынке. Такие обзоры не считаются рекламой, ели они оформлены в едином стиле наряду с другими товарами или услугами. Если при размещении информации о товарах и услугах нарушается единообразие, и один из объектов выделяется размером, цветом, форматом подачи, то такой объект уже будет считаться рекламой и его следует маркировать.',
      ],
    },
    {
      subTitle: 'Самореклама. Реклама или нет?',
      text: [
        'Напомним, рекламой не является информация, размещенная на официальном сайте и в социальных сетях компании, если эти сведения направлены на информирование о:',
        <ul>
          <li>товарах или услугах;</li>
          <li>правилах использования;</li>
          <li>условиях приобретения;</li>
          <li>хозяйственной деятельности организации;</li>
          <li>ценах и скидках;</li>
          <li>акциях и мероприятиях.</li>
        </ul>,
        'Специальные акции, предложения и любые элементы, которые выделяются в ассортименте товаров и привлекают внимание считаются рекламой.',
        'Например, если на вашем сайте размещен отдельный баннер с предложением приобрести конкретный товар, то это также является рекламой. Такой баннер необходимо зарегистрировать в ОРД, где в специальном блоке Личного кабинета выбрать пункт «самореклама».',
        'Отличие «саморекламы» от «рекламы» заключается также и в подаче отчётности в ОРД, где для «саморекламы» в качестве отчёта передаётся только статистика показов по креативу (рекламному сообщению/публикации), в то время как при подаче отчётности по «рекламе» вместе с отчётом передаются также сведения о контрагентах и сопутствующих договорах и актах.',
      ],
    },
    {
      subTitle: 'Добавление рекламного маркера (erid)',
      text: [
        'Чтобы избежать штрафов, согласно приказу Роскомнадзора от 30 ноября 2022 года № 191, во все рекламные публикации должен быть добавлен рекламный маркер (erid: xxxxx). Получить его можно в ОРД, при регистрации рекламных данных.',
        <>
          О порядке размещения рекламного маркера в публикациях мы писали{' '}
          <a href="/blog/poryadok_razmeshenia_markera_v_reklame">здесь</a>.
        </>,
      ],
    },
    {
      subTitle: 'Отчётность в ОРД',
      text: [
        'Лицо, ответственное за маркировку рекламы, обязано отчитываться о каждой рекламе в личном кабинете ОРД. Передать данные о рекламной публикации необходимо в течение 30 дней, следующих за месяцем публикации.',
        'Важно отметить: отчётность должна подаваться на протяжении всей активности рекламы. Если ваша реклама размещается на протяжении года, то и отчитываться по ней нужно в течение этого года ежемесячно.',
      ],
    },
    {
      subTitle: 'Что делать, если остались вопросы?',
      text: [
        'Для разъяснения сложных кейсов по порядку регистрации данных вы всегда можете обратиться в клиентскую поддержку ОРД от SberAds. Вам постараются ответить, либо в исключительных случаях подскажут в какой компетентный государственный орган обратиться за разъяснениями (ЕРИР, РКН, ФАС). Не забывайте и сами следить за разъяснениями Роскомнадзора, чтобы избежать административных санкций, связанных с маркировкой рекламы.',
      ],
    },
  ],
};

export default otvetstvennost_za_shtrafi;
